import { h } from "preact";

export function StreamingIndicator() {
  return (
    <div class="widget-streaming">
      <span class="widget-streaming-dot" />
      <span class="widget-streaming-dot" />
      <span class="widget-streaming-dot" />
    </div>
  );
}
